// src/gtm.js

export function initGtm() {
  const gtmId = process.env.REACT_APP_TAG_MANAGER_ID;

  if (!gtmId) {
    console.warn('REACT_APP_TAG_MANAGER_ID is missing');
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const firstScript = document.getElementsByTagName('script')[0];
  const script = document.createElement('script');

  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;

  firstScript.parentNode.insertBefore(script, firstScript);
}
